import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { imgPos } from "@/lib/api";
import { SeasonalTag } from "@/components/SeasonalTag";

export const ProductCard = ({ p, index }) => (
  <Link to={`/shop/${p.slug}`} data-testid={`product-card-${p.slug}`} className="group block">
    <div className="relative aspect-[4/5] overflow-hidden bg-linen">
      <img
        src={p.images?.[0]}
        alt={p.name}
        className={`absolute inset-0 w-full h-full object-cover ${imgPos(p.images?.[0])} transition-transform duration-[1.4s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.06]`}
      />
      <span className="absolute top-4 left-4 text-[11px] tracking-[0.28em] uppercase bg-cream/90 px-3 py-1.5">{p.category}</span>
      {p.seasonal && <span data-testid={`product-card-seasonal-${p.slug}`} className="absolute top-4 right-4 bg-espresso/90 text-cream px-3 py-1.5"><SeasonalTag /></span>}
    </div>
    <div className="flex items-start justify-between gap-4 pt-5">
      <div>
        <p className="text-xs text-mocha tracking-[0.2em]">{String(index + 1).padStart(2, "0")}</p>
        <h3 className="font-display text-3xl mt-1 leading-tight">{p.name}</h3>
        <p className="text-sm text-mocha mt-1">{p.price_note}</p>
      </div>
      <span className="mt-6 w-11 h-11 rounded-full border border-espresso/20 flex items-center justify-center transition-[background-color,color,transform] duration-500 group-hover:bg-espresso group-hover:text-cream group-hover:rotate-45">
        <ArrowUpRight className="w-4 h-4" strokeWidth={1.4} />
      </span>
    </div>
  </Link>
);
